import React from 'react'
import {options} from '../data'
import {
	ApiRequestFailedEventArgs,
	PaymentContent,
	RefundableProvider
} from 'protect-group-pulse-react'
import TestForm from '../components/TestForm'

export default function Refundable() {

	const handleApiError = (args: ApiRequestFailedEventArgs) => {
		console.log('Api error', args.method, args.error)
	}

	return (
		<RefundableProvider options={options}>
			<div className="p-5">
				<div className="flex items-center justify-between mb-5 w-full">
					<h1 className="font-medium text-3xl text-pulse-blue">Refundable Demo</h1>
					<a className="font-medium text-xl text-pulse-blue" href="/">Home</a>
				</div>
				<div className="px-5">
					<PaymentContent
						onApiError={handleApiError}
					/>
				</div>
				<div className="px-5">
					<TestForm
						options={options}
					/>
				</div>
				<div className="flex px-5">
					<a href="/back-office" className="text-sky-500">Back Office</a>
				</div>
			</div>
		</RefundableProvider>
	)
}
